<!-- 关于我们 -->
<template>
  <div class="content">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "about");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  width: 1000px;
  margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue